<template>
  <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

    <header class="widget-header">
      <h2 class="widget-title">{{ title }}</h2>
      <h3 class="widget-title-period">
        <span>Annualisé</span>
      </h3>

      <div class="widget-actions-container">
        <widget-dropdown v-model="type" :options="types" :callback="filter"></widget-dropdown>
      </div>

    </header>

    <div class="widget-preloader">
      <div class="pre-loader">
        <div class="box1"></div>
        <div class="box2"></div>
        <div class="box3"></div>
        <div class="box4"></div>
        <div class="box5"></div>
      </div>
    </div>

    <div class="widget-content" v-if="stats.dataset">

      <div class="widget-content-datas">
        <div class="data-labels">

          <div class="data-label" v-for="item in stats.dataset" style="padding: 0;">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ item.data.reduce((a, b) => a + b, 0)|formatNumber }}</strong>
            <span class="legend">Total {{ item.name }} TTC</span>
          </div>
        </div>

      </div>

      <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" @click="setChartToFull">
        <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
      </div>
    </div>
  </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Chart from '../../../components/chart/Spline.vue'

    export default {
      name: 'Widget',
      components: {
        'chart' : Chart
      },
      props: ['title','type','className','branch'],
      data () {
        return {
          types: [
            {id: 'all', label: 'Global'},
            {id: 'web', label: 'Web uniquement'},
            {id: 'direct', label: 'Direct uniquement'}
          ],
          forceRefresh: null,
          loaded: false,
          stats: {
            dataset: null,
            labels: null
          },
          dateFilter: {
            start_at: '',
            end_at: '',
          },
          showAdvancedFilterVue: false,
          count: null,
          total: null,
          currency: null,
          is_ttc: true,
          options: {
            tooltips: {
              callbacks: {
                labelx: function(tooltipItem, data) {
                  // Hide the label by returning an empty string
                  return '';
                }
              }
            },
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
                fontSize: 10,
                fontFamily: 'Gotham Rounded',
                fontWeight: 300
              }
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            scales: {
              xAxes: [ {
                categoryPercentage: 0.9,
                barPercentage: 0.9,
                stacked: false,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: false,
                  display: false,
                  color: "#eeeeee",
                  drawBorder: false
                },
                ticks: {
                  display: true,
                  fontColor: "#cccccc",
                  fontSize: 10,
                  mirror: false,
                  padding: 0,
                  align: 'start',
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                },
              }],
              yAxes: [ {
                stacked: false,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: true,
                  display: true,
                  color: "#eeeeee",
                  borderDashOffset: 1,
                  borderDash: [2,2],
                  drawBorder: false
                },
                ticks: {
                  display: true,
                  fontColor: "#cccccc",
                  fontSize: 10,
                  padding: 0,
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                  //stepSize: 1,
                  //suggestedMax: 0,
                  //suggestedMin: 0
                }
              }]
            }
          }
        }
      },
      mounted: function(){
        this.currency = this.$store.state.scope.currency_id
        this.is_ttc = this.$store.state.scope.is_ttc
        this.type = this.type

        this.filter(this.type);

      },
      methods: {
        setChartToFull: function()
        {
          this.options.layout.padding = {
            left: -10,
            right: 0,
            top: 0,
            bottom: -10
          };
          this.options.scales.xAxes[0].ticks.display = true;
          this.options.scales.xAxes[0].gridLines.display = true;
          this.options.scales.yAxes[0].ticks.display = true;

        },
        filter: function(type)
        {

            this.loaded = false;
            this.type = type

            InvoiceService.getStatsCompare( this.type, this.branch).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels

              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })

        },
      }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsCompareWidget.vue